import { chainedRef } from '@/utils'
import React from 'react'
import scrollIntoView from 'scroll-into-view-if-needed'

export default React.forwardRef(function TextEdit(
  {
    value,
    onChange,
    ...props
  }: Omit<
    React.InputHTMLAttributes<HTMLInputElement>,
    'value' | 'onChange' | 'defaultValue'
  > & {
    value: string
    onChange: (value: string | undefined) => void
  },
  fwdRef: React.ForwardedRef<HTMLInputElement>
) {
  const ref = React.useRef<HTMLInputElement>(null)
  React.useEffect(() => {
    scrollIntoView(ref.current!, { block: 'center', inline: 'center' })
    ref.current!.select()
    ref.current!.focus()
  }, [])
  const onBlur = React.useCallback(() => {
    onChange(ref.current!.value)
  }, [onChange])
  const onKeyDown = React.useCallback(
    (e: React.KeyboardEvent) => {
      switch (e.key) {
        case 'Enter':
          ref.current!.blur()
          break
        case 'Esc':
        case 'Escape':
          onChange(undefined)
          break
        // no default
      }
    },
    [onChange]
  )
  const onClick = React.useCallback((e: React.MouseEvent) => {
    e.stopPropagation()
    e.preventDefault()
  }, [])
  const compRef = React.useMemo(() => chainedRef(fwdRef, ref), [fwdRef])
  return (
    <input
      {...props}
      defaultValue={value}
      ref={compRef}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
      onClick={onClick}
      maxLength={36}
    />
  )
})
